import { Routes } from '@angular/router';
import { EstruturaOrganizacionalLista } from '@/features/configuracoes/registro/estrutura-organizacional/estrutura-organizacional-lista/estrutura-organizacional-lista';
import { EstruturaOrganizacionalDetalhe } from '@/features/configuracoes/registro/estrutura-organizacional/estrutura-organizacional-detalhe/estrutura-organizacional-detalhe';
import { FuncionarioLista } from '@/features/configuracoes/registro/funcionario/funcionario-lista/funcionario-lista';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

const rootPath = CONFIGURACOES_ROUTES.REGISTRO.ROOT;

export const configuracoesRegistroRoutes: Routes = [
    {
        path: rootPath,
        data: { breadcrumb: 'Registro' },
        children: [
            { path: '', redirectTo: CONFIGURACOES_ROUTES.REGISTRO.ESTRUTURAS, pathMatch: 'full' },
            { path: CONFIGURACOES_ROUTES.REGISTRO.ESTRUTURAS, component: EstruturaOrganizacionalLista, data: { breadcrumb: 'Estruturas' } },
            { path: CONFIGURACOES_ROUTES.REGISTRO.ESTRUTURAS_DETALHE, component: EstruturaOrganizacionalDetalhe, data: { breadcrumb: 'Estrutura Organizacional' } },
            {
                path: CONFIGURACOES_ROUTES.REGISTRO.FUNCIONARIOS,
                component: FuncionarioLista,
                canActivate: [permissionGuard],
                // Escopo, nao a role de visualizar: o gate de acesso casa por prefixo, entao quem so
                // tem 'criar' ou 'editar' tambem entra na tela.
                data: { breadcrumb: 'Funcionários', permission: PERMISSOES.configuracoes.funcionarios.escopo }
            }
        ]
    }
];

export default configuracoesRegistroRoutes;
